import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "insurancePaid",
    "chosenPriceBeforePatientResponsibility",
    "chosenPriceAfterPatientResponsibility",
    "priceOption",
    "negotiationReason"
  ]

  connect() {
    // Initialize the price selection to match the reason/price.
    this.onNegotiationReasonChange();
  }

  onChosenPriceSelectionChange(e) {
    this.updatePriceBeforeInsurance();

    // If the selected price has a corresponding negotiation reason, then automatically pick it.
    if (this.priceOptionTarget.selectedIndex >= 0) {
      const selectedOption = this.priceOptionTarget.options[this.priceOptionTarget.selectedIndex];
      const correspondingNegotiationReason = selectedOption.getAttribute('data-negotiation-reason');
      if (correspondingNegotiationReason != "" && this.negotiationReasonTarget.value != correspondingNegotiationReason) {
        this.negotiationReasonTarget.value = correspondingNegotiationReason;
      }
    }
  }

  onNegotiationReasonChange() {
    // If the selected reason has a corresponding price option / value, then automatically set them.
    const selectedOption = this.negotiationReasonTarget.options[this.negotiationReasonTarget.selectedIndex];
    const correspondingPrice = selectedOption.getAttribute('data-price');
    if (correspondingPrice) {
      this.priceOptionTarget.value = "Other";
      this.chosenPriceBeforePatientResponsibilityTarget.value = correspondingPrice;
    } else if (this.negotiationReasonTarget.value != '') {
      // Check if there's a price option that has this reason.  If so, pick it.
      var found = false;
      for (var i = 0; i < this.priceOptionTarget.options.length; i++) {
        const priceOption = this.priceOptionTarget.options[i];
        if (priceOption.getAttribute('data-negotiation-reason') == this.negotiationReasonTarget.value) {
          this.priceOptionTarget.selectedIndex = i;
          found = true;
          break;
        }
      }
      if (!found) {
        if (this.chosenPriceBeforePatientResponsibilityTarget.value == '') {
          this.priceOptionTarget.value = '';
        } else {
          this.priceOptionTarget.value = "Other";
        }
      }
    }
    this.updatePriceBeforeInsurance();
  }

  // This updates the numeric input field's visiblity/value based on what's chosen in the price options select input.
  updatePriceBeforeInsurance() {
    const value = this.priceOptionTarget.value;
    if (value == 'Other') {
      this.chosenPriceBeforePatientResponsibilityTarget.classList.remove('hidden');
    } else {
      this.chosenPriceBeforePatientResponsibilityTarget.classList.add('hidden');
    }

    if (value != '' && value != 'Other') {
      this.chosenPriceBeforePatientResponsibilityTarget.value = value;
    }
    this.updatePriceAfterInsurance();
  }

  updatePriceAfterInsurance() {
    // Note that this logic is repeated in bill_item#patient_responsibility_after_negotiation
    if (this.insurancePaidTarget.innerText != '') {
      const insurancePaid = Number(this.insurancePaidTarget.innerText.replace(/[^0-9.-]+/g,""));
      let chosenPriceAfter = this.chosenPriceBeforePatientResponsibilityTarget.value - insurancePaid;
      // If we have a *coding* reason for negotiation, it's OK to let this line item go negative.
      // Otherwise, we should cap it at zero.
      if (this.negotiationReasonTarget.value.indexOf('Coding') < 0) {
        chosenPriceAfter = Math.max(0.0, chosenPriceAfter);
      }
      const formattedPrice = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(chosenPriceAfter);
      this.chosenPriceAfterPatientResponsibilityTarget.innerText = formattedPrice;
    }
  } 
}